<div class="sparkling">
  <div class="ball {{showSparkles}}"></div>
  <div class="sparkles" *ngIf="showSparkles">
    <div class="sp" *ngFor="let item of createRange(150);"></div>
  </div>
</div>